<template>
    <div>
        <b-modal :visible="isModalVisible" @hidden="hideModal" no-close-on-backdrop hide-footer body-class="p-2" header-class="bg-light align-items-center" size="lg">
            <div slot="modal-title">
                <h3 class="h4 text-dark font-weight-light m-0">
                    {{ 'Pievienot OVP amatam' }}
                </h3>
            </div>
            <div slot="modal-header-close">
            </div>
            <OvpByJobTitleBaseForm @finished="handleOvpLinking"/>
        </b-modal>
        <SkeletonLoader v-if="isLoading" :skeleton-data="skeletonData"/>
        <JobTitlesList v-else/>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import JobTitlesList from '@/components/job-titles/JobTitlesList';
    import OvpByJobTitleBaseForm from '@/components/job-titles/OvpByJobTitleBaseForm';
    import * as jobTitleStoreTypes from '../../vuex/modules/company/modules/job-titles/job-title.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import {SkeletonLoaderRepository} from '../global/skeleton-loader/SkeletonLoaderRepository';
    import SkeletonLoader from '@/components/global/skeleton-loader/SkeletonLoader';

    export default {
        name: 'ovp-by-job-title',
        components: {JobTitlesList, SkeletonLoader, OvpByJobTitleBaseForm},
        data: () => ({searchTerm: '', skeletonData: SkeletonLoaderRepository.usersListLayout}),
        computed: {
            ...mapGetters('jobTitle', {
                /** @type {boolean} */
                isLoading: jobTitleStoreTypes.GET_IS_LOADING,
                 /** @type {boolean|*} */
                isModalVisible: jobTitleStoreTypes.GET_IS_MODAL_VISIBLE,
            }),
            ...mapGetters('company', {
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
        },
        methods: {
            ...mapMutations('company', {
                /** @type {function|*} */
                setCurrentCompanyJobTitles: companyStoreTypes.SET_CURRENT_COMPANY_JOB_TITLES,
            }),
            ...mapActions('jobTitle', {
                 /** @type {function|*} */
                getJobTitles: jobTitleStoreTypes.ACTION_GET_JOB_TITLES,
                /** @type {function|*} */
                showModal: jobTitleStoreTypes.ACTION_SHOW_MODAL,
                /** @type {function|*} */
                hideModal: jobTitleStoreTypes.ACTION_HIDE_MODAL,
            }),
            async handleOvpLinking() {
                this.hideModal();
                const jobTitles = await this.getJobTitles({companyId: this.$route.params.companyId || this.currentCompany.id});
                this.setCurrentCompanyJobTitles(jobTitles);
            },
        }
    }
</script>
